import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10341417")

_pushScopeId("data-v-10341417")
const _hoisted_1 = { class: "review" }
const _hoisted_2 = { class: "content_ls_margin" }
const _hoisted_3 = { class: "ls-slate-dark" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "band-3" }
const _hoisted_8 = {
  key: 0,
  class: "personal-details"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("h3", null, "Personal Details", -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Name")
], -1)
const _hoisted_12 = { class: "col-8" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "LawID number")
], -1)
const _hoisted_15 = { class: "col-8" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "PC holder")
], -1)
const _hoisted_18 = { class: "col-8" }
const _hoisted_19 = {
  key: 0,
  class: "row"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Year of admission")
], -1)
const _hoisted_21 = { class: "col-8" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Law Society Member")
], -1)
const _hoisted_24 = { class: "col-8" }
const _hoisted_25 = {
  key: 1,
  class: "employment-details"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("h3", null, "Employment Details", -1)
const _hoisted_27 = {
  key: 0,
  class: "row"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Law practice name")
], -1)
const _hoisted_29 = { class: "col-8" }
const _hoisted_30 = {
  key: 1,
  class: "row"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Firm / Organisation name")
], -1)
const _hoisted_32 = { class: "col-8" }
const _hoisted_33 = {
  key: 2,
  class: "row"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Employment status")
], -1)
const _hoisted_35 = { class: "col-8" }
const _hoisted_36 = {
  key: 2,
  class: "contact-details"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("h3", null, "Committee Contact Details", -1)
const _hoisted_38 = { class: "row" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Committee postal address")
], -1)
const _hoisted_40 = { class: "col-8" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Committee phone number")
], -1)
const _hoisted_44 = { class: "col-8" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Committee email address")
], -1)
const _hoisted_48 = { class: "col-8" }
const _hoisted_49 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("h3", null, "Are your Personal, Employment and Committee Contact details correct?", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("h4", null, "Serving on a Law Society Committee is a significant time commitment. While we provide the option to list preferences for up to three committees, we note that many applicants only wish to serve on one committee. Please indicate whether you have the capacity to serve on more than one committee.", -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("h4", null, "Please outline your expertise/practice areas/activities/experience directly relevant to the committees you have applied for. Where you have previously served, or are currently on, one of these committees, please set out your contribution to the work of that committee ", -1)
const _hoisted_59 = { class: "textarea" }
const _hoisted_60 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("h4", null, "Why do you wish to join your nominated committee(s)?", -1)
const _hoisted_62 = { class: "textarea" }
const _hoisted_63 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("h4", null, "Please list any publications/articles you have authored/contributed to in the last two years, relevant to the committee(s) you are applying for.", -1)
const _hoisted_65 = { class: "textarea" }
const _hoisted_66 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("h4", null, "Please let us know if you have any suggestions for us to improve the committee application process.", -1)
const _hoisted_68 = { class: "textarea" }
const _hoisted_69 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("h4", null, "Preferences.", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_72 = { class: "checkboxes" }
const _hoisted_73 = /*#__PURE__*/_createVNode("h4", null, "Email Preferences", -1)
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { class: "col-12" }
const _hoisted_77 = { class: "checkbox-button" }
const _hoisted_78 = /*#__PURE__*/_createVNode("input", {
  type: "checkbox",
  disabled: "disabled",
  checked: "checked"
}, null, -1)
const _hoisted_79 = { class: "checkbox-elmt" }
const _hoisted_80 = /*#__PURE__*/_createVNode("span", { class: "checkmark-box" }, [
  /*#__PURE__*/_createVNode("span", { class: "checkmark" })
], -1)
const _hoisted_81 = { class: "checkbox-text" }
const _hoisted_82 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_83 = /*#__PURE__*/_createVNode("h4", null, "Areas of Interest", -1)
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { class: "col-12" }
const _hoisted_87 = { class: "checkbox-button" }
const _hoisted_88 = /*#__PURE__*/_createVNode("input", {
  type: "checkbox",
  disabled: "disabled",
  checked: "checked"
}, null, -1)
const _hoisted_89 = { class: "checkbox-elmt" }
const _hoisted_90 = /*#__PURE__*/_createVNode("span", { class: "checkmark-box" }, [
  /*#__PURE__*/_createVNode("span", { class: "checkmark" })
], -1)
const _hoisted_91 = { class: "checkbox-text" }
const _hoisted_92 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_93 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_94 = { key: 0 }
const _hoisted_95 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("I have read the "),
  /*#__PURE__*/_createVNode("a", {
    target: "blank",
    href: "https://www.lawsociety.com.au/privacy-policy/personal-information-collection-notice"
  }, "Personal Information Collection Notice"),
  /*#__PURE__*/_createTextVNode(" and consent to The Law Society of New South Wales’ collection, use and disclosure of information in accordance with that Notice.")
], -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_97 = { class: "checkbox outline" }
const _hoisted_98 = /*#__PURE__*/_createVNode("label", { for: "review_checkbox" }, "Yes, I have read and agree to the Notice ", -1)
const _hoisted_99 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    (_ctx.isLoadingData)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.pageHeader), 1),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createVNode("div", _hoisted_7, [
        (_ctx.personalDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode("div", _hoisted_12, [
                  _createVNode("p", null, _toDisplayString(_ctx.personalDetail.displayName), 1)
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode("div", _hoisted_15, [
                  _createVNode("p", null, _toDisplayString(_ctx.personalDetail.lawId), 1)
                ])
              ]),
              _createVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode("div", _hoisted_18, [
                  _createVNode("p", null, _toDisplayString(_ctx.personalDetail?.isPcHolder ? 'Yes' : 'No'), 1)
                ])
              ]),
              (_ctx.isPcHolder)
                ? (_openBlock(), _createBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode("div", _hoisted_21, [
                      _createVNode("p", null, _toDisplayString(_ctx.personalDetail.admissionYear), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode("div", _hoisted_24, [
                  _createVNode("p", null, _toDisplayString(_ctx.personalDetail.memberDescription), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.employmentDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_25, [
              _hoisted_26,
              (_ctx.isPcHolder)
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode("div", _hoisted_29, [
                      _createVNode("p", null, _toDisplayString(_ctx.employmentDetail.firmName), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isPcHolder)
                ? (_openBlock(), _createBlock("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode("div", _hoisted_32, [
                      _createVNode("p", null, _toDisplayString(_ctx.employmentDetail.firmName), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isPcHolder)
                ? (_openBlock(), _createBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _createVNode("div", _hoisted_35, [
                      _createVNode("p", null, _toDisplayString(_ctx.personalDetail.solicitorTypeDescription), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.committeeContactDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_36, [
              _hoisted_37,
              _createVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode("div", _hoisted_40, [
                  (_ctx.committeeContactDetail.address)
                    ? (_openBlock(), _createBlock("p", _hoisted_41, [
                        _createVNode("pre", null, _toDisplayString(_ctx.getAddressEncoded()), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_42, [
                _hoisted_43,
                _createVNode("div", _hoisted_44, [
                  (_ctx.committeeContactDetail.phone)
                    ? (_openBlock(), _createBlock("p", _hoisted_45, _toDisplayString(_ctx.getPhoneNumber()), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_46, [
                _hoisted_47,
                _createVNode("div", _hoisted_48, [
                  (_ctx.committeeContactDetail.email)
                    ? (_openBlock(), _createBlock("p", {
                        key: 0,
                        title: _ctx.committeeContactDetail.email,
                        class: "email"
                      }, _toDisplayString(_ctx.committeeContactDetail.email), 9, ["title"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_49,
      _hoisted_50,
      _hoisted_51,
      _createVNode("p", null, _toDisplayString(_ctx.getConfirmationText), 1),
      _hoisted_52,
      _hoisted_53,
      _createVNode("h3", null, "Expression of interest " + _toDisplayString(_ctx.committeeYear), 1),
      _hoisted_54,
      _hoisted_55,
      _createVNode("p", null, _toDisplayString(_ctx.eoi.isSingleCommitteeOnly ? 'No' : 'Yes'), 1),
      _hoisted_56,
      _createVNode("h4", null, "Which " + _toDisplayString(_ctx.committeeYear) + " committee(s) would you like to apply for as your preference?", 1),
      _createVNode("ol", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.eoi.committeeMembers, (ec) => {
          return (_openBlock(), _createBlock("li", null, [
            _createVNode("p", null, _toDisplayString(ec.committeeName), 1)
          ]))
        }), 256))
      ]),
      _hoisted_57,
      _hoisted_58,
      _createVNode("p", _hoisted_59, _toDisplayString(_ctx.eoi.response1), 1),
      _hoisted_60,
      _hoisted_61,
      _createVNode("p", _hoisted_62, _toDisplayString(_ctx.eoi.response2), 1),
      _hoisted_63,
      _hoisted_64,
      _createVNode("p", _hoisted_65, _toDisplayString(_ctx.eoi.response3), 1),
      _hoisted_66,
      _hoisted_67,
      _createVNode("p", _hoisted_68, _toDisplayString(_ctx.eoi.response4), 1),
      _hoisted_69,
      _hoisted_70,
      _hoisted_71,
      _createVNode("div", _hoisted_72, [
        _hoisted_73,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.initialEmailPreferencesList, (e) => {
          return (_openBlock(), _createBlock("div", _hoisted_74, [
            (e.isSelected)
              ? (_openBlock(), _createBlock("div", _hoisted_75, [
                  _createVNode("div", _hoisted_76, [
                    _createVNode("label", _hoisted_77, [
                      _hoisted_78,
                      _createVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _createVNode("span", _hoisted_81, _toDisplayString(e.preferenceTypeDisplayName), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 256)),
        _hoisted_82,
        _hoisted_83,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.initialAreaOfInterestsList, (a) => {
          return (_openBlock(), _createBlock("div", _hoisted_84, [
            (a.isSelected)
              ? (_openBlock(), _createBlock("div", _hoisted_85, [
                  _createVNode("div", _hoisted_86, [
                    _createVNode("label", _hoisted_87, [
                      _hoisted_88,
                      _createVNode("div", _hoisted_89, [
                        _hoisted_90,
                        _createVNode("span", _hoisted_91, _toDisplayString(a.name), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 256))
      ]),
      _hoisted_92,
      _hoisted_93,
      (!_ctx.isReviewing)
        ? (_openBlock(), _createBlock("div", _hoisted_94, [
            _hoisted_95,
            _hoisted_96,
            _createVNode("div", _hoisted_97, [
              _withDirectives(_createVNode("input", {
                type: "checkbox",
                id: "review_checkbox",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.agreeCheck = $event)),
                onChange: _cache[2] || (_cache[2] = $event => (_ctx.setAgreeCheck()))
              }, null, 544), [
                [_vModelCheckbox, _ctx.agreeCheck]
              ]),
              _hoisted_98
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_99
  ]))
})